export default {
  components: {
    Faqs: () => import('~/components/commom/faqs/index'),
    Team: () => import('~/components/commom/team/index'),
    FooterBlock: () => import('~/components/commom/footer/index'),
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    HowItWorks: () => import('~/components/layouts/how-it-works/index'),
    LifeInsuranceCompanies: () =>
      import('~/components/layouts/life-insurance-companies/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      companies: [],
      faqs: [
        {
          title: this.$i18n.t('What is a life insurance?'),
          content: this.$i18n.t(
            "Credit life insurance is a contract whereby the insurer undertakes to pay the agreed capital upon the insured's death (death insurance) or survival (life insurance). Life insurance may also include supplementary coverages that provide financial support in case of disability of the insured person. By taking out life insurance, the insured can also benefit from daily financial support while hospitalized."
          )
        },
        {
          title: this.$i18n.t(
            'What are the main differences between the life insurance?'
          ),
          content: this.$i18n.t(
            "The mortgage life insurance covers the risk of death (natural or by accident), which ensures that the household receives financial support in the event of the insured person's death during the contract period. The amount receivable is calculated according to the insured's capital and age, and it is proportional. The mortgage life insurance covering the risk of survival ensures that the beneficiary receives the agreed capital if the insured person is alive at the end of the contract. These arrangements are important for making savings and the beneficiaries may be the insured themselves. There are mixed modalities that reconcile the two situations."
          )
        },
        {
          title: this.$i18n.t(
            'What are the main mortgage life insurance coverage?'
          ),
          content: this.$i18n.t(
            'Mortgage life insurance may include diagnoses of serious illnesses such as cancer, stroke or myocardial infarction, absolute and permanent disability (IAD), death by car accident, total and permanent disability (ITP), funeral allowance, daily hospitalization allowance by accident, among other examples. Associated coverages may increase the insurance premium, but in return increase the amount of available capital.'
          )
        },
        {
          title: this.$i18n.t('Is the mortgage life insurance mandatory?'),
          content: this.$i18n.t(
            'According to the law, it is not mandatory to have a mortgage life insurance, but this is usually a requirement of the bank that loans you the money. The existence of a life insurance allows the bank to recover the contracted capital in the event of death, absolute and permanent disability or total and permanent disability of the insured.'
          )
        },
        {
          title: this.$i18n.t('Should I have a credit life insurance?'),
          content: this.$i18n.t(
            'Yes, we advise you to contract a mortgage life insurance to prevent the devastating economic consequences for you and your family in case of premature death, serious accident or illness.In addition, life insurance brings your premium deductions n the IRS (maximum 25% of total premiums paid, with a maximum of 64 euros per individual and 128 euros per couple).'
          )
        },
        {
          title: this.$i18n.t('What coverages should I contract?'),
          content: this.$i18n.t(
            'When contracting the mortgage life insurance, you should take into account the coverage required by the lending bank but also the degree of protection you want for yourself and your family.'
          )
        },
        {
          title: this.$i18n.t(
            'Do I have to take credit life insurance at the bank?'
          ),
          content: this.$i18n.t(
            'It is not mandatory to do mortgage life insurance with the bank. By the way, you can even save a lot of money if you icontract your insurance kweeder.com.The law 222/2009 clarified the right of the mortgage customer to choose the best option for life insurance. While the bank offers you some spread bonuses, the insurance solution offered by the bank is not always the best option.'
          )
        },
        {
          title: this.$i18n.t(
            'What should you do before contracting the mortgage life insurance?'
          ),
          content: this.$i18n.t(
            'You should always start by doing a simulation here. The advanced comparison tools available at kweeder.com allows you to compare the mortgage  life insurance coverage from the best solution in the market, the first year premium, the premium accrued over the life of the insurance, the guaranteed capital for any of the coverage as well as your exclusions. Carefully read the exclusions for each product. Insurance usually does not cover extreme sports, some illnesses and low levels of disability and you should be aware of all exceptions.'
          )
        },
        {
          title: this.$i18n.t(
            'What information is required to perform a simulation on Kweeder.com?'
          ),
          content: this.$i18n.t(
            'In order to perform a mortgage life insurance simulation you need to provide your personal details and the mortgage details like the outstanding principal, loan life years and current premium amount paid. Based on this information, we instantly calculate the insurance premiums tailored to your personal circumstances as well as actual savings for the first year. The insurance comparison also gives you an indication of the total premium paid during the term of your mortgage. This indicator gives you an accurate indication of the best financial offer for your insurance.'
          )
        },
        {
          title: this.$i18n.t(
            'Is it possible to obtain an insurance contract online?'
          ),
          content: this.$i18n.t(
            "Yes it is possible to make a valid contract online and/or by phone. In the same way a contract is concluded in person, the conclusion of a contract online or by phone requires the submission of your insurance company and contract's information."
          )
        }
      ]
    }
  },
  methods: {
    sendSimulationEvent() {
      this.$gtm.pushEvent({
        event: 'life_middle'
      })
    },
    async fetchCompanies() {
      return await this.$axios.get('/companies/active', {
        params: { productType: 8 }
      })
    }
  },
  beforeMount() {
    this.fetchCompanies().then(({ data }) => {
      this.companies = Object.values(data)
    })
  }
}
